import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import htmlParser from 'html-react-parser';
import { SANITIZE_MODE, sanitizeStepContent } from '../../shared/utils/sanitizeStepContent';

/**
 * Shared heading, reference graphic, and instruction HTML for workflow step nodes.
 * Uses display sanitization (allows http presigned URLs from API resolution in local dev).
 */
export default function WorkflowStepInstruction({
  graphic,
  heading,
  text,
  headingFallback,
  textClassName,
  showHeading = true,
  graphicOnly = false,
}) {
  const { graphic: safeGraphic, text: safeText } = useMemo(
    () => sanitizeStepContent({ graphic, text }, SANITIZE_MODE.DISPLAY),
    [graphic, text]
  );

  const parsedContent = safeText ? htmlParser(safeText) : null;
  const displayHeading = heading || headingFallback || '';
  const graphicAlt = heading || headingFallback || 'Reference';

  if (graphicOnly) {
    if (!safeGraphic) return null;
    return (
      <div className="text-center mb-3">
        <img
          src={safeGraphic}
          alt={graphicAlt}
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </div>
    );
  }

  return (
    <>
      {safeGraphic && (
        <div className="text-center mb-3">
          <img
            src={safeGraphic}
            alt={graphicAlt}
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </div>
      )}
      {showHeading && displayHeading && <h2>{displayHeading}</h2>}
      {parsedContent && (
        textClassName ? <div className={textClassName}>{parsedContent}</div> : parsedContent
      )}
    </>
  );
}

WorkflowStepInstruction.propTypes = {
  graphic: PropTypes.string,
  heading: PropTypes.string,
  text: PropTypes.string,
  headingFallback: PropTypes.string,
  textClassName: PropTypes.string,
  showHeading: PropTypes.bool,
  graphicOnly: PropTypes.bool,
};

WorkflowStepInstruction.defaultProps = {
  graphic: '',
  heading: '',
  text: '',
  headingFallback: '',
  textClassName: '',
  showHeading: true,
  graphicOnly: false,
};
